<template>
  <div class="contentText">
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-row>
        <v-col cols="12" md="10" lg="9">
          <v-text-field
            v-model="name_org"
            :counter="50"
            :rules="name_orgRules"
            :label="name_orgLabelComputed"
            class="inputStyle"
            prepend-inner-icon="house"
            required
            outlined
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="10" lg="9">
          <v-text-field
            v-model="adress"
            :label="adressLabelComputed"
            class="inputStyle"
            prepend-inner-icon="place"
            outlined
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="10" lg="9">
          <v-text-field
            v-model="email"
            :label="emailLabelComputed"
            :rules="this.emailRules"
            class="inputStyle"
            prepend-inner-icon="alternate_email"
            outlined
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="10" lg="9">
          <VuePhoneNumberInput
            v-model="phone"
            v-on:update="updatePhone"
            v-bind:translations="myTranslation"
            :rules="this.emailRules"
            required
            class="mt-lg-2 mt-md-0"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="10" lg="9">
          <v-select
            v-model="request_type"
            :items="this.items"
            :rules="this.request_typeRules"
            :label="request_typeLabelComputed"
            class="Style mt-6"
            prepend-inner-icon="done"
            required
            outlined
            :menu-props="{ attach: true, offsetY: true }"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="10" lg="9">
          <v-checkbox
            v-model="privacyAccepted"
            :rules="[v => !!v || 'Обязательное поле']"
            hide-details="auto"
            class="mt-0 pt-0"
            color="light-green darken-4"
          >
            <template #label>
              <span style="font-size: 14px;">
                {{ $t('message.privacyConsentPrefix') }}<a href="/file/acceptance_policy_tii.doc" target="_blank" rel="noopener noreferrer" style="color: #33691E; text-decoration: underline;" @click.stop>{{ $t('message.privacyConsentLink') }}</a>
              </span>
            </template>
          </v-checkbox>
          <div class="mt-3 mb-4" style="font-size: 12px; color: rgba(0,0,0,0.6); line-height: 1.2;">
            {{ $t('message.privacyPolicyPrefix') }}<a href="/file/privacy_policy_tii.pdf" target="_blank" rel="noopener noreferrer" style="color: #33691E; text-decoration: underline;" @click.stop>{{ $t('message.privacyPolicyLink') }}</a>{{ $t('message.privacyPolicyAnd') }}<a href="/file/cookie_policy_tii.doc" target="_blank" rel="noopener noreferrer" style="color: #33691E; text-decoration: underline;" @click.stop>{{ $t('message.cookiePolicyLink') }}</a>
          </div>
        </v-col>
      </v-row>
      <div v-if="isAuth && changeData">
        <v-btn @click="pushChangeContent">Изменить</v-btn>
      </div>
      <v-row>
        <v-col cols="12" lg="4" md="5" sm="4">
          <v-btn
            class="px-15"
            outlined
            x-large
            v-on:click="send()"
            color="light-green darken-4"
            >{{ $t("message.partnershipForSuppliersForm10") }}</v-btn
          >
          <v-dialog v-model="dialog" width="300">
            <v-card>
              <v-card-text class="pt-6 pb-8 circle-check">
                <i class="material-icons mr-5 mt-3 ml-2">check_circle</i>
                <p>{{ $t("message.partnershipForSuppliersForm13") }}</p>
              </v-card-text>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialog_error" width="300">
            <v-card>
              <v-card-text class="pt-6 pb-8 circle-check">
                <i class="cansel-icon material-icons mr-5 mt-3 ml-2">cancel</i>
                <p>{{ $t("message.partnershipForSuppliersForm14") }}</p>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import VuePhoneNumberInput from "vue-phone-number-input";
export default {
  components: { VuePhoneNumberInput },
  props: {
    name_orgLabel: { type: String, default: "" },
    adressLabel: { type: String, default: "" },
    emailLabel: { type: String, default: "" },
    request_typeLabel: { type: String, default: "" },
    phoneLabel: { type: String, default: "" },
    id_name_orgLabel: { type: [Number, String], default: undefined },
    id_adressLabel: { type: [Number, String], default: undefined },
    id_emailLabel: { type: [Number, String], default: undefined },
    id_phoneLabel: { type: [Number, String], default: undefined },
    id_request_typeLabel: { type: [Number, String], default: undefined },
    change: { type: Boolean, default: undefined },
  },
  methods: {
    updatePhone: function (value) {
      console.log(value);
    },
    getT18nData(i18n_data, id_content) {
      if (i18n_data == "") {
        return { value_rus: i18n_data, value_eng: i18n_data, id_content: id_content };
      }
      const ru = Object.entries(this.$i18n.messages["ru"].message).find(([, v]) => v === i18n_data);
      if (ru) {
        return {
          value_rus: this.$i18n.messages["ru"].message[ru[0]],
          value_eng: this.$i18n.messages["en-US"].message[ru[0]],
          id_content: id_content,
        };
      }
      const en = Object.entries(this.$i18n.messages["en-US"].message).find(([, v]) => v === i18n_data);
      if (en) {
        return {
          value_rus: this.$i18n.messages["ru"].message[en[0]],
          value_eng: this.$i18n.messages["en-US"].message[en[0]],
          id_content: id_content,
        };
      }
      return { value_rus: i18n_data, value_eng: i18n_data, id_content: id_content };
    },
    pushChangeContent() {
      const content_to_change = {
        name_orgLabel: this.name_orgLabelData,
        adressLabel: this.adressLabelData,
        emailLabel: this.emailLabelData,
        phoneLabel: this.phoneLabelData,
        request_typeLabel: this.request_typeLabelData,
      };
      this.$store.dispatch("contentChanges/SET_CONTENT_TO_CHANGE", {
        type_to_change: "OfferGoodsForm",
        content_to_change,
      });
      this.$router.push("/change_content");
    },
    send: function () {
      if (this.validateForm)
        this.$store.dispatch("mail/SEND_REQUESTFORM", {
          name_org: this.name_org,
          adress: this.adress,
          phone: this.phone,
          email: this.email,
          request_type: this.request_type,
        });
      else this.$store.dispatch("mail/SHOW_REQUESTERROR");
    },
  },
  computed: {
    isAuth() {
      return this.$store.getters["adminAuth/checkAuth"];
    },
    changeData() {
      if (this.change === false) return false;
      const hasIds =
        this.id_name_orgLabel ||
        this.id_adressLabel ||
        this.id_emailLabel ||
        this.id_phoneLabel ||
        this.id_request_typeLabel;
      return !!hasIds;
    },
    name_orgLabelComputed() {
      if (this.name_orgLabelData && (this.name_orgLabelData.value_rus || this.name_orgLabelData.value_eng))
        return this.$i18n.locale === "ru" ? this.name_orgLabelData.value_rus : this.name_orgLabelData.value_eng;
      return this.$t("message.partnershipForSuppliersForm1");
    },
    adressLabelComputed() {
      if (this.adressLabelData && (this.adressLabelData.value_rus || this.adressLabelData.value_eng))
        return this.$i18n.locale === "ru" ? this.adressLabelData.value_rus : this.adressLabelData.value_eng;
      return this.$t("message.partnershipForSuppliersForm2");
    },
    emailLabelComputed() {
      if (this.emailLabelData && (this.emailLabelData.value_rus || this.emailLabelData.value_eng))
        return this.$i18n.locale === "ru" ? this.emailLabelData.value_rus : this.emailLabelData.value_eng;
      return this.$t("message.partnershipForSuppliersForm3");
    },
    request_typeLabelComputed() {
      if (this.request_typeLabelData && (this.request_typeLabelData.value_rus || this.request_typeLabelData.value_eng))
        return this.$i18n.locale === "ru" ? this.request_typeLabelData.value_rus : this.request_typeLabelData.value_eng;
      return this.$t("message.partnershipForSuppliersForm5");
    },
    validateForm: function () {
      if (!this.name_org || !(this.name_org.length < 50)) return false;
      if (!this.request_type) return false;
      if (!this.email || !/.+@.+\..+/.test(this.email)) return false;
      if (!this.privacyAccepted) return false;
      return true;
    },
    myTranslation() {
      let phoneNumberLabel = this.$t("message.partnershipForSuppliersForm7");
      if (this.phoneLabelData && (this.phoneLabelData.value_rus || this.phoneLabelData.value_eng))
        phoneNumberLabel = this.$i18n.locale === "ru" ? this.phoneLabelData.value_rus : this.phoneLabelData.value_eng;
      return {
        countrySelectorLabel: this.$t("message.partnershipForSuppliersForm6"),
        countrySelectorError: this.$t("message.partnershipForSuppliersForm6Error"),
        phoneNumberLabel,
        example: this.$t("message.partnershipForSuppliersForm7Example"),
      };
    },
    dialog: {
      get() {
        return this.$store.state["mail"]["requestFormLoad"];
      },
      set(value) {
        this.name_org = "";
        this.adress = "";
        this.phone = "";
        this.email = "";
        this.request_type = "";
        this.$store.dispatch("mail/HIDE_FORM", "requestFormLoad");
      },
    },
    dialog_error: {
      get() {
        return this.$store.state["mail"]["requestFormError"];
      },
      set(value) {
        this.$store.dispatch("mail/HIDE_FORM", "requestFormError");
      },
    },
  },
  name: "OfferGoodsForm",
  data() {
    const idList = [
      this.id_name_orgLabel,
      this.id_adressLabel,
      this.id_emailLabel,
      this.id_phoneLabel,
      this.id_request_typeLabel,
    ].filter((id) => id !== undefined && id !== null);
    const defaultNameOrg = this.$t("message.partnershipForSuppliersForm1");
    const defaultAdress = this.$t("message.partnershipForSuppliersForm2");
    const defaultEmail = this.$t("message.partnershipForSuppliersForm3");
    const defaultRequestType = this.$t("message.partnershipForSuppliersForm5");
    const defaultPhone = this.$t("message.partnershipForSuppliersForm7");
    const _name_org = this.getT18nData(this.name_orgLabel || defaultNameOrg, this.id_name_orgLabel);
    const _adress = this.getT18nData(this.adressLabel || defaultAdress, this.id_adressLabel);
    const _email = this.getT18nData(this.emailLabel || defaultEmail, this.id_emailLabel);
    const _phone = this.getT18nData(this.phoneLabel || defaultPhone, this.id_phoneLabel);
    const _request_type = this.getT18nData(this.request_typeLabel || defaultRequestType, this.id_request_typeLabel);
    const self = this;
    if (idList.length) {
      this.$store.dispatch("contentChanges/GET_CONTENT", { id_list: idList }).then(() => {
        const content = this.$store.getters["contentChanges/content"] || [];
        content.forEach((c) => {
          const id = parseInt(c.id_content);
          if (id === parseInt(self.id_name_orgLabel)) {
            _name_org.value_rus = c.value_rus;
            _name_org.value_eng = c.value_eng;
          }
          if (id === parseInt(self.id_adressLabel)) {
            _adress.value_rus = c.value_rus;
            _adress.value_eng = c.value_eng;
          }
          if (id === parseInt(self.id_emailLabel)) {
            _email.value_rus = c.value_rus;
            _email.value_eng = c.value_eng;
          }
          if (id === parseInt(self.id_phoneLabel)) {
            _phone.value_rus = c.value_rus;
            _phone.value_eng = c.value_eng;
          }
          if (id === parseInt(self.id_request_typeLabel)) {
            _request_type.value_rus = c.value_rus;
            _request_type.value_eng = c.value_eng;
          }
        });
      });
    }
    return {
      name_orgLabelData: _name_org,
      adressLabelData: _adress,
      emailLabelData: _email,
      phoneLabelData: _phone,
      request_typeLabelData: _request_type,
      items: [
        "заявка на ремонт",
        "заявка на техническое обслуживание",
        "заявка на заключение комплексного договора на техническое обслуживание и ремонт на календарный год",
      ],
      valid: true,
      privacyAccepted: false,
      name_org: "",
      adress: "",
      request_type: "",
      request_typeRules: [(v) => !!v || "Обязательное поле"],
      name_orgRules: [
        (v) => !!v || "Обязательное поле",
        (v) =>
          (v && v.length <= 50) ||
          "Название организации должно содержать не более 50 символов",
      ],
      email: "",
      emailRules: [
        (v) => !!v || "Обязательное поле",
        (v) =>
          /.+@.+\..+/.test(v) || "Электронная почта должна быть действительной",
      ],
      phone: "",
    };
  },
};
</script>

<style scoped></style>
